import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Select,
  MenuItem,
} from "@mui/material";
import { useState } from "react";

const ProductReplacement = ({
  requested_products,
  selectedProduct,
  onConfirm,
  onCancel,
}) => {
  const [selectedReplacementCode, setSelectedReplacementCode] = useState("");

  const handleConfirm = () => {
    if (selectedReplacementCode) {
      onConfirm(selectedReplacementCode);
    }
  };

  return (
    <Dialog
      open={Boolean(selectedProduct)}
      onClose={onCancel}
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle>Sélectionnez un produit à remplacer</DialogTitle>
      <DialogContent>
        <p>{`Le produit sélectionné "${selectedProduct?.product_name}" ne correspond à aucun produit demandé.`}</p>
        <Select
          fullWidth
          value={selectedReplacementCode}
          onChange={(e) => setSelectedReplacementCode(e.target.value)}
          displayEmpty
        >
          <MenuItem value="">Choisir le produit à remplacer</MenuItem>
          {requested_products.map((product) => (
            <MenuItem key={product.product_code} value={product.product_code}>
              {product.title} - {product.product_code}
            </MenuItem>
          ))}
        </Select>
      </DialogContent>
      <DialogActions>
      <div className="dialogBottom">
       
        <Button onClick={onCancel} className="submit_but cancel_but" variant="contained">
          Annuler
        </Button>
        <Button
          onClick={handleConfirm}
          className="submit_but valide_but"
          disabled={!selectedReplacementCode}variant="contained"
        >
          Confirmer
        </Button>
      
      </div>
      </DialogActions>
    </Dialog>
  );
};
export default ProductReplacement;
